exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact.component.less
// module id = ../../../../../src/app/contact/contact.component.less
// module chunks = main